var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTakePhoto(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6668 14.8333C19.6668 15.2754 19.4912 15.6993 19.1787 16.0118C18.8661 16.3244 18.4422 16.5 18.0002 16.5H3.00016C2.55814 16.5 2.13421 16.3244 1.82165 16.0118C1.50909 15.6993 1.3335 15.2754 1.3335 14.8333V5.66667C1.3335 5.22464 1.50909 4.80072 1.82165 4.48816C2.13421 4.17559 2.55814 4 3.00016 4H6.3335L8.00016 1.5H13.0002L14.6668 4H18.0002C18.4422 4 18.8661 4.17559 19.1787 4.48816C19.4912 4.80072 19.6668 5.22464 19.6668 5.66667V14.8333Z",
    stroke: "white",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5002 13.1667C12.3411 13.1667 13.8335 11.6743 13.8335 9.83333C13.8335 7.99238 12.3411 6.5 10.5002 6.5C8.65921 6.5 7.16683 7.99238 7.16683 9.83333C7.16683 11.6743 8.65921 13.1667 10.5002 13.1667Z",
    stroke: "white",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTakePhoto);
export default __webpack_public_path__ + "static/media/take-photo.c690e8b18d6480d903a8dfa2a8f32384.svg";
export { ForwardRef as ReactComponent };